import React from "react";
import Slider from "../../Slider/Slider";

const JoomlaDev = () => {
  return (
    <>
      <div
        class="inner-page"
        id="nodejs-design-bg"
        data-aos="fade-up"
        data-aos-duration="1500"
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-5">
              <div
                class="inner_content"
                data-aos="fade-up"
                data-aos-duration="2000"
              >
                <h1>Joomla Development</h1>
                <div aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <a href="index.html">
                        <i class="ri-home-4-line"></i>Home
                      </a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      Joomla Development
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="section">
        <div className="bg-body-tertiary">
          <div className="container pt-5">
            <div className="row align-items-center">
              <div className="col-md-6">
                <h2 className="section-title">
                  Joomla Web Development Company
                </h2>
                <p className="">
                  Being a reputable Joomla web development company in India, we
                  have been serving clients across various business verticals.
                  Using the latest version of this amazing CMS and its user
                  friendly features & extensions, we have created a loyal chain
                  of satisfied clientele. Our experienced Joomla developers have
                  thorough technical knowledge and expertise in developing
                  functional websites to meet the specific business requirements
                  of our clients. We also provide customization services of
                  existing Joomla website, Joomla version upgrade and post
                  deployment maintenance & support. Avail our Joomla web
                  development services and allow us to provide you with an
                  enhanced Joomla experience.
                </p>

                <a href="contact.html" className="btn1 mt-lg-0 mt-2">
                  Request a quote
                </a>
                <button className="btn1">Case Study</button>
              </div>
              <div className="col-md-6">
                <img
                  src="https://www.webguru-india.com/assets/images/joomla-development-services-loj.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Why choose us starts*/}
      <section className="section " data-aos="fade-up" data-aos-duration={1500}>
        <div className="container" data-aos="fade-up" data-aos-duration={1500}>
          <h2 className="section-title text-start py-3">
            Our Joomla Website Development Services
          </h2>
          <p>
            As a highly experienced Joomla website development company in India,
            we provide every possible service with this CMS platform. Check out
            the list of our services:
          </p>
        </div>
        <div className="details-website">
          <div className="container pb-5">
            <div className="row g-2">
              <div className="col-md-4">
                <div className="d-flex align-items-center">
                  <i class="ri-code-box-line icon-color mr-3"></i>
                  <p className="m-0">Joomla Website Development</p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="d-flex align-items-center">
                  <i class="ri-code-box-line icon-color mr-3"></i>
                  <p className="m-0">Joomla Theme Customization</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex align-items-center">
                  <i class="ri-code-box-line icon-color mr-3"></i>
                  <p className="m-0">Custom Modules Development</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex align-items-center">
                  <i class="ri-code-box-line icon-color mr-3"></i>
                  <p className="m-0">Joomla Application Development</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex align-items-center">
                  <i class="ri-code-box-line icon-color mr-3"></i>
                  <p className="m-0">Joomla Extension Integration</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex align-items-center">
                  <i class="ri-code-box-line icon-color mr-3"></i>
                  <p className="m-0">Joomla Website Maintenance</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex align-items-center">
                  <i class="ri-code-box-line icon-color mr-3"></i>
                  <p className="m-0">Joomla Customization Services</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex align-items-center">
                  <i class="ri-code-box-line icon-color mr-3"></i>
                  <p className="m-0">Joomla Migration Services</p>
                </div>
              </div>
            </div>
            <button className="btn3 btn_gap">What's Your Project</button>
            <button className="btn3">Our Creation</button>
          </div>
        </div>
      </section>
      {/* why choose us ends */}
     
      <section
        className="our_clientele_sec section"
        data-aos="fade-up"
        data-aos-duration={1500}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div
                className="heading row_gap"
                data-aos="fade-up"
                data-aos-duration={2000}
              >
                <h2>Our Clients</h2>
              </div>
            </div>
          </div>
          <div className="row row-cols-lg-6 g-2 row-cols-md-5 row-cols-sm-4 row-cols-3 justify-content-center align-items-center ">
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/client-1.webp"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/client-2.webp"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/client-3.webp"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/client-4.webp"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/client-5.webp"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/client-6.webp"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/client-7.webp"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/client-8.webp"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/client-9.webp"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/client-10.webp"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/client-11.webp"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/client-12.webp"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Slider />
      <section className="section" data-aos="fade-up" data-aos-duration={1500}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div
                className="heading row_gap"
                data-aos="fade-up"
                data-aos-duration={2000}
              >
                <h2>Tools &amp; Technologies </h2>
              </div>
            </div>
          </div>
          <div className="row row-cols-lg-6 g-2 row-cols-md-5 row-cols-sm-4 row-cols-3 justify-content-center align-items-center ">
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-1.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-2.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-3.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-4.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-5.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-6.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-7.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-8.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-9.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-10.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-11.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg">
              <div
                className="client_box"
                data-aos="zoom-in"
                data-aos-duration={2000}
              >
                <img
                  src="assets/image/tools-12.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="section bg_color_secondary"
        data-aos="fade-up"
        data-aos-duration={1500}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-md-7 blog-left wow fadeInLeft"
              data-wow-duration="0.5s"
              data-wow-delay="0.0s"
            >
              <h2 className="section-title">From Our Blog</h2>
              <div className="blog-inner">
                <h4 className="section-subtitle">
                  The Best Chatbot Plugins for WordPress in 2023
                </h4>
                <p>
                  Chatbots have become increasingly popular in recent years as a
                  way for businesses to interact with customers and automate
                  certain tasks. WordPress is one of the most widely used
                  content management systems among website design companies and
                  there are a variety of chatbot plugins that can be easily
                  integrated into WordPress websites.
                </p>
                <button className="btn1">Read Blog Post</button>
              </div>
            </div>
            <div
              className="col-md-5 hidden-xs blog-right wow fadeInRight"
              data-wow-duration="0.5s"
              data-wow-delay="0.0s"
            >
              <div className="blog-image-holder">
                <img
                  className="msd-lazyload loaded"
                  src="https://www.webguru-india.com/assets/images/wordpress-development-services-blog.jpg"
                  alt="blog-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default JoomlaDev;
